import React, { useContext } from 'react';

import { AnimatePresence } from 'framer-motion';
import { ThemeContext } from 'styled-components';

// TODO: `components` should not import from `pages`.
import YatTextReveal from '@pkg/components/Sections/Profile/TextReveal';

import { CollectionLink } from '@app/pages/Collection/components/CollectionLink';

import { Typography } from '../../../DesignSystem';

import { CollectionAndChildrenWrapper, NFTCollectionWrapper, StyledVerificationIcon } from './styles';

interface Props {
    className?: string;
    children?: React.ReactNode;
    collection?: string;
    verified?: boolean;
    typographySize?: 16 | 20;
    hidden?: boolean;
    collectionSlug?: string;
}

const YatNFTCollection = ({
    className,
    children,
    collection = '',
    verified,
    typographySize = 16,
    hidden,
    collectionSlug,
}: Props) => {
    const theme = useContext(ThemeContext);

    // todo check collection
    const Collection = collection && (
        <Typography type="label" size={typographySize} weight="400">
            <CollectionLink slug={collectionSlug}>
                <YatTextReveal text={collection} state={hidden ? 'exit' : undefined} preventOverflow />
            </CollectionLink>
        </Typography>
    );

    return (
        <NFTCollectionWrapper className={className}>
            <AnimatePresence>
                {!hidden && verified && collection && (
                    <StyledVerificationIcon
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: theme.transitions.speeds.normal }}
                    />
                )}
            </AnimatePresence>
            {children ? (
                <CollectionAndChildrenWrapper>
                    {Collection}
                    {children}
                </CollectionAndChildrenWrapper>
            ) : (
                Collection
            )}
        </NFTCollectionWrapper>
    );
};

export default YatNFTCollection;
